//  top program slider
let swiperTopProgram = null;

function initSwiper() {
    if (window.innerWidth > 767) {
        if (!swiperTopProgram) {
            swiperTopProgram = new Swiper('.top__program__slider', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: false,
                speed: 800,
                navigation: {
                    nextEl: '.top__program-next',
                    prevEl: '.top__program-prev',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
            });
        }
    } else {
        if (swiperTopProgram) {
            swiperTopProgram.destroy(true, true);
            swiperTopProgram = null;
        }
    }
};

initSwiper();
window.addEventListener('resize', initSwiper);
